export type CidrValidation = 'ok' | 'invalid' | 'too_wide';

const IPV4 = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

const isIpv6 = (value: string): boolean => {
  if (!value.includes(':') || value.includes(':::')) {
    return false;
  }
  const halves = value.split('::');
  if (halves.length > 2) {
    return false;
  }
  const groups = halves
    .flatMap((half) => (half === '' ? [] : half.split(':')))
    .filter((group) => group.length > 0);
  if (groups.some((group) => !/^[0-9a-fA-F]{1,4}$/.test(group))) {
    return false;
  }
  if (halves.length === 2) {
    return groups.length < 8;
  }
  return groups.length === 8;
};

const prefixOf = (raw: string | undefined, max: number): number | 'missing' | 'invalid' => {
  if (raw === undefined) {
    return 'missing';
  }
  if (!/^\d+$/.test(raw)) {
    return 'invalid';
  }
  const prefix = Number(raw);
  if (prefix < 0 || prefix > max) {
    return 'invalid';
  }
  return prefix;
};

export function validateCidr(value: string): CidrValidation {
  const trimmed = value.trim();
  const parts = trimmed.split('/');
  if (!trimmed || parts.length > 2) {
    return 'invalid';
  }
  const [address, prefixRaw] = parts;
  if (address.includes(':')) {
    if (!isIpv6(address)) {
      return 'invalid';
    }
    const prefix = prefixOf(prefixRaw, 128);
    if (prefix === 'invalid') {
      return 'invalid';
    }
    if (prefix !== 'missing' && prefix < 48) {
      return 'too_wide';
    }
    return 'ok';
  }
  if (!IPV4.test(address)) {
    return 'invalid';
  }
  const prefix = prefixOf(prefixRaw, 32);
  if (prefix === 'invalid') {
    return 'invalid';
  }
  if (prefix !== 'missing' && prefix < 24) {
    return 'too_wide';
  }
  return 'ok';
}
